import { render, staticRenderFns } from "./xjffCheckItem.vue?vue&type=template&id=521e050c&scoped=true"
import script from "./xjffCheckItem.vue?vue&type=script&lang=js"
export * from "./xjffCheckItem.vue?vue&type=script&lang=js"
import style0 from "./xjffCheckItem.vue?vue&type=style&index=0&id=521e050c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e050c",
  null
  
)

export default component.exports